$(document).ready(function() {

	var config = {
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 600,
		fade: true,
		cssEase: 'ease',
		pauseOnHover: false
	};

	$(".stat-slider").on('init afterChange', function(event, slick, currentSlide, nextSlide) {
		// find current slide
		for (var i = 0; i < slick.$slides.length; i++) {
			var $slide = $(slick.$slides[i]);
			if ($slide.hasClass('slick-current')) {
				$slide.prev().removeClass('active');
				$slide.next().removeClass('active');
				setTimeout(function() {
					$slide.addClass('active');
				}, 300);
				break;
			} else {}
		}
	});

	$('.stat-col:nth-child(1) .stat-slider').slick(config);

	setTimeout(function() {
		$('.stat-col:nth-child(2) .stat-slider').slick(config);
		$('body').addClass('loaded');
	}, 300);

	setTimeout(function() {
		$('.stat-col:nth-child(3) .stat-slider').slick(config);
	}, 600);
});
